<ce-layout-side-panel>
    <ce-core-side-nav-menu [navigationList]="navigationListComputed()" />

    <ce-inline-banner
        [action]="{ label: 'ChargEye classic', href: classicUrl, icon: 'arrow-right' }"
        [hideIcon]="true"
        class="u-spacing-md-ma"
        content="We are building an entirely new ChargEye. Most of the features still today are in ChargEye classic."
        heading="Welcome to ChargEye beta"
        state="important"
    />

    <div sidenav-footer>
        @if (hasTenancies()) {
        <ce-core-side-nav-org-switch [orgName]="organisationName()" />

        @if (userName() !== '') {
        <ce-core-side-nav-profile-options [userName]="userName()" />
        } }
    </div>
</ce-layout-side-panel>
